export default function BookmarkIcon({ ...props }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor" {...props}>
			<path d="M185.869-98.52v-681.393q0-32.74 23.356-56.262 23.355-23.521 55.862-23.521h429.826q32.74 0 56.262 23.521 23.521 23.522 23.521 56.262v681.392L480-224.173 185.869-98.521Zm79.218-120.393L480-309.087l214.913 90.174v-561H265.087v561Zm0-561h429.826-429.826Z" />
		</svg>
	)
}
